import { render, staticRenderFns } from "./Folders.vue?vue&type=template&id=e1cf8dc8&scoped=true&"
import script from "./Folders.vue?vue&type=script&lang=js&"
export * from "./Folders.vue?vue&type=script&lang=js&"
import style0 from "./Folders.vue?vue&type=style&index=0&id=e1cf8dc8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1cf8dc8",
  null
  
)

export default component.exports